function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, toRefs, reactive, ref, watch, getCurrentInstance } from "vue";
import { ElSchemaFormItem } from "el-schema-form";
import _ from "lodash";
import { formItemList, formValue, rules } from "@/views/producer/ics-authorization/components/authorization-dialog-option";
import { fetchAdvertiserList } from "@/api/advertiser/manage";
import { definePropType } from "@types-vue/props";
import { createICSAdvertiser, updateICSAdvertiser } from "@/api/ics_advertiser/manage";
import { format } from "date-fns";
export default defineComponent({
    props: {
        action: {
            type: definePropType(String),
            default: "create"
        },
        formItemInfo: {
            type: definePropType(Object),
            default: function() {
                return {};
            }
        }
    },
    components: {
        ElSchemaFormItem: ElSchemaFormItem
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var form = ref();
        var loading = ref(false);
        var rulesData = reactive({
            rules: rules
        });
        var advertiserList = ref([]);
        var formValueData = reactive({
            formValue: formValue
        });
        var formItemListData = reactive({
            formItemList: formItemList
        });
        var getAdvertiserList = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(params) {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return fetchAdvertiserList(params);
                        case 2:
                            res = _ctx.sent;
                            advertiserList.value = (_.get(res, "data.data.list") || []).map(function(item) {
                                return _objectSpreadProps(_objectSpread({}, item), {
                                    value: item.id,
                                    label: item.name
                                });
                            });
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function getAdvertiserList(params) {
                return _ref.apply(this, arguments);
            };
        }();
        /** 重置表单 */ var resetFields = function() {
            var _$ref;
            (_$ref = form.value) === null || _$ref === void 0 ? void 0 : _$ref.resetFields();
        };
        watch(function() {
            return props.formItemInfo;
        }, function(val) {
            if (props.action === "update") {
                advertiserList.value = [
                    {
                        value: val.ssUid,
                        label: val.ssUsername
                    }, 
                ];
                formValueData.formValue = _.assign(_.pick(val, [
                    "accountType",
                    "subAccountNum",
                    "expireIn",
                    "limitFlag",
                    "ssUid",
                    "id",
                    "email",
                    "ssUsername", 
                ]), {
                    imgSum: val.imgSum === -1 ? 100 : val.imgSum,
                    videoSum: val.videoSum === -1 ? 100 : val.videoSum
                });
            } else {
                formValueData.formValue = _.cloneDeep(formValue);
                resetFields();
            }
        }, {
            immediate: true
        });
        var handleChange = function(obj) {
            _.set(formValueData.formValue, "".concat(obj.prop), obj.value);
        };
        var cancel = function() {
            // resetFields()
            emit("cancel");
        };
        var successMassageEvent = function(code) {
            if (code === 0) {
                root.$message.success("\u64CD\u4F5C\u6210\u529F");
                loading.value = false;
                cancel();
                emit("save-form");
            }
        };
        var submit = function() {
            var _ref1 = _asyncToGenerator(regeneratorRuntime.mark(function _callee1() {
                var _$ref;
                return regeneratorRuntime.wrap(function _callee$(_ctx1) {
                    while(1)switch(_ctx1.prev = _ctx1.next){
                        case 0:
                            ;
                            if (form) {
                                _ctx1.next = 3;
                                break;
                            }
                            return _ctx1.abrupt("return");
                        case 3:
                            _ctx1.next = 5;
                            return (_$ref = form.value) === null || _$ref === void 0 ? void 0 : _$ref.validate(function() {
                                var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(valid, fields) {
                                    var res, list, res1;
                                    return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                if (!valid) {
                                                    _ctx.next = 26;
                                                    break;
                                                }
                                                loading.value = true;
                                                if (!(props.action === "update")) {
                                                    _ctx.next = 15;
                                                    break;
                                                }
                                                _ctx.prev = 3;
                                                _ctx.next = 6;
                                                return updateICSAdvertiser(_.assign(formValueData.formValue, {
                                                    expireIn: format(formValueData.formValue.expireIn, "YYYY-MM-DD")
                                                }));
                                            case 6:
                                                res = _ctx.sent;
                                                successMassageEvent(res.data.code);
                                                _ctx.next = 13;
                                                break;
                                            case 10:
                                                _ctx.prev = 10;
                                                _ctx.t0 = _ctx["catch"](3);
                                                loading.value = false;
                                            case 13:
                                                _ctx.next = 26;
                                                break;
                                            case 15:
                                                list = advertiserList.value.filter(function(item) {
                                                    return item.value === formValueData.formValue.ssUid;
                                                });
                                                _ctx.prev = 16;
                                                _ctx.next = 19;
                                                return createICSAdvertiser(_.assign(formValueData.formValue, {
                                                    email: list[0].email,
                                                    ssUsername: list[0].name,
                                                    expireIn: format(formValueData.formValue.expireIn, "YYYY-MM-DD")
                                                }));
                                            case 19:
                                                res1 = _ctx.sent;
                                                successMassageEvent(res1.data.code);
                                                _ctx.next = 26;
                                                break;
                                            case 23:
                                                _ctx.prev = 23;
                                                _ctx.t1 = _ctx["catch"](16);
                                                loading.value = false;
                                            case 26:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee, null, [
                                        [
                                            3,
                                            10
                                        ],
                                        [
                                            16,
                                            23
                                        ]
                                    ]);
                                }));
                                return function(valid, fields) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                        case 5:
                        case "end":
                            return _ctx1.stop();
                    }
                }, _callee1);
            }));
            return function submit() {
                return _ref1.apply(this, arguments);
            };
        }();
        return _objectSpreadProps(_objectSpread({
            form: form
        }, toRefs(formValueData), toRefs(formItemListData)), {
            advertiserList: advertiserList,
            loading: loading,
            rulesData: rulesData,
            handleChange: handleChange,
            submit: submit,
            cancel: cancel,
            resetFields: resetFields,
            getAdvertiserList: getAdvertiserList
        });
    }
});
